const appConfig = {
  apiPrefix: "https://api.trabo.ai",
  googleAnalyticsMesurementId: "G-YJ3NXJ69KM",
  paypalPlanID: "P-4HV12026VY972320BMXFXSAA",
  authenticatedEntryPathUser: "/market",
  authenticatedEntryPathAdmin: "/instances",
  userUnAuthenticatedEntryPath: "/sign-in",
  adminUnAuthenticatedEntryPath: "/admin",
  tourPath: "/",
  enableMock: false,
  dataController: "Trabo Company",
  googleClientId:
    "895916144452-ftlsr1dlu4vg12afpfmliuucocgbei87.apps.googleusercontent.com",
};

export default appConfig;
